import React, { Component } from "react";
import {
  Collapse,
  Navbar,
  NavbarBrand,
  NavbarToggler,
  NavItem,
  NavLink,
  Dropdown,
  DropdownItem,
  DropdownToggle,
  DropdownMenu,
  Tooltip
} from "reactstrap";
import { Link } from "react-router-dom";
import "./NavMenu.css";

export class NavMenu extends Component {
  static displayName = NavMenu.name;

  constructor(props) {
    super(props);

    this.toggleNavbar = this.toggleNavbar.bind(this);
    this.state = {
      collapsed: true,
      tooltip1: false,
      tooltip2: false
    };
  }

  toggleNavbar() {
    this.setState({
      collapsed: !this.state.collapsed,
    });
  }

  toggle1 = () => {
    this.setState(prevState => ({ tooltip1: !prevState.tooltip1 }));
  };

  toggle2 = () => {
    this.setState(prevState => ({ tooltip2: !prevState.tooltip2 }));
  };

  render() {
    return (
      <header>
        <Navbar
          className="navbar-expand-sm navbar-toggleable-sm ng-white border-bottom box-shadow mb-3"
          container
          light
        >
          <NavbarBrand tag={Link} to="/">
            <i className="bi bi-currency-bitcoin" style={{ color: "red" }}></i>{" "}
            <span style={{ color: "green" }}>bitcoin.bio</span>
          </NavbarBrand>
          <NavbarToggler onClick={this.toggleNavbar} className="mr-2" />
          <Collapse className="d-sm-inline-flex flex-sm-row-reverse" isOpen={!this.state.collapsed} navbar>
            <ul className="navbar-nav flex-grow">
              <NavItem>
                <NavLink id="navHome" tag={Link} className="text-dark" to="/"><i className="bi bi-house-fill"></i></NavLink>
              </NavItem>
              <NavItem>
                <NavLink id="navTool" tag={Link} className="text-dark" to="/tools"><i className="bi bi-tools"></i></NavLink>
              </NavItem>
              <Tooltip placement="bottom" isOpen={this.state.tooltip1} target="navHome" toggle={this.toggle1} >Home</Tooltip>
              <Tooltip placement="bottom" isOpen={this.state.tooltip2} target="navTool" toggle={this.toggle2} >Tools</Tooltip>
            </ul>
          </Collapse>
        </Navbar>
      </header>
    );
  }
}
